import { SezionaliFetchParams } from '../../../models';
import { apiClient } from '../../../helpers';
import { AxiosResponse } from 'axios';
import { handleError, URL_GESTIFY_SEZIONALI } from '../../../utils';
import { getGestifyTokenCookies } from '../../../helpers/authCookies';

export const gestifyFetchSezionali = async (
  params: Partial<SezionaliFetchParams> | undefined,
): Promise<any> => {
  try {
    const token = getGestifyTokenCookies().gestifyToken;
    const response = await apiClient.get<AxiosResponse>({
      url: `${URL_GESTIFY_SEZIONALI}`,
      params: { ...params, token },
    });
    if (response.status >= 200 || response.status < 300) {
      return { data: response.data, params };
    }

    return handleError(response.status, response.data?.status);
  } catch (error: any) {
    return handleError(
      error?.response?.status ?? error?.message,
      error?.response?.data,
    );
  }
};
